
const validate = (formType, formData) => {
  switch (formType) {
    case 'changePassword':
      return changePassword(formData);
    case 'saveBank':
      return saveBank(formData);
    case 'addEditFrontDeskAccount':
      return addEditFrontDeskAccount(formData);
    case 'locationAddEdit':
      return locationAddEdit(formData);
    case 'practiceProfileEdit':
      return practiceProfileEdit(formData);
    case 'createPractice':
      return createPractice(formData);
    case 'userProfileEdit':
      return userProfileEdit(formData);
    case 'signIn':
      return validateSignIn(formData);
    case 'signUp':
      return validateSignUp(formData);
    case 'instantSignUp':
      return validateInstantSignUp(formData);
    case 'instantSignIn':
      return validateInstantSignIn(formData);
    default:
      return { valid: true };
  }
}

const validateInstantSignIn = (data) => {
  var errors = [];
  var fields = {};

  if (data.email === '') {
    errors.push('Email is a required field');
    fields['email'] = true;
  }

  if (data.password === '') {
    errors.push('Password is a required field');
    fields['password'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const validateInstantSignUp = (data) => {
  var errors = [];
  var fields = {};

  if (data.email === '') {
    errors.push('Email is a required field');
    fields['email'] = true;
  }

  if (data.password === '') {
    errors.push('Password is a required field');
    fields['password'] = true;
  }

  if (data.password !== '' && validatePasswordText(data.password)) {
    errors.push('Password contains Invalid Character(s) \nMust be a-z A-Z 0-9 @$!?%*');
    fields['password'] = true;
  }

  if (data.password !== '' && data.confirm_password !== data.password) {
    errors.push('Password and Confirm Password do not match');
    fields['password'] = true;
    fields['confirm_password'] = true;
  }

  if (data.email !== '' && data.confirm_email !== data.email) {
    errors.push('Email and Confirm Email do not match');
    fields['email'] = true;
    fields['confirm_email'] = true;
  }

  if (data.practice_name === '') {
    errors.push('Practice Name is a required field');
    fields['practice_name'] = true;
  }

  if (data.phone === '') {
    errors.push('Phone is a required field');
    fields['phone_number'] = true;
  }

  if (data.street_address === '') {
    errors.push('Street Address is a required field');
    fields['street_address'] = true;
  }

  if (data.city === '') {
    errors.push('City is a required field');
    fields['city'] = true;
  }

  if (data.state === '') {
    errors.push('State is a required field');
    fields['state'] = true;
  }

  if (data.zipcode === '') {
    errors.push('Zipcode is a required field');
    fields['zipcode'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };

}

const changePassword = (data) => {
  var errors = [];
  var fields = {};

  if (!data.newPassword) {
    errors.push('New Password is a required field');
    fields['newPassword'] = true;
  }

  if (!data.confirmNewPassword) {
    errors.push('Confirm New Password is a required field');
    fields['confirmNewPassword'] = true;
  }

  if (data.confirmNewPassword !== data.newPassword) {
    errors.push('New Password and Confirm New Password do not match');
    fields['newPassword'] = true;
    fields['confirmNewPassword'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const saveBank = (data) => {
  var errors = [];
  var fields = {};

  if (!data.routing_number) {
    errors.push('Routing Number is a required field');
    fields['routingNumber'] = true;
  }

  if (!data.account_number) {
    errors.push('Account Number is a required field');
    fields['accountNumber'] = true;
  }

  if (!data.currentBankExists && !data.email) {
    errors.push('Email is a required field');
    fields['email'] = true;
  }

  if (!data.currentBankExists && !data.legal_entity.dob.day) {
    errors.push('DOB is a required field');
    fields['ownerDOBDay'] = true;
  }

  if (!data.currentBankExists && !data.legal_entity.dob.month) {
    errors.push('DOB is a required field');
    fields['ownerDOBDay'] = true;
  }

  if (!data.currentBankExists && !data.legal_entity.dob.year) {
    errors.push('DOB is a required field');
    fields['ownerDOBYear'] = true;
  }

  if (!data.currentBankExists && !data.legal_entity.first_name) {
    errors.push('Owner First name is a required field');
    fields['ownerfirstName'] = true;
  }

  if (!data.currentBankExists && !data.legal_entity.last_name) {
    errors.push('Owner Last name is a required field');
    fields['ownerlastName'] = true;
  }

  if (!data.currentBankExists && !data.legal_entity.business_name) {
    errors.push('Business name is a required field');
    fields['businessName'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const addEditFrontDeskAccount = (data) => {
  var errors = [];
  var fields = {};

  if (data.email === '') {
    errors.push('Email is a required field');
    fields['email'] = true;
  }

  if (data.admin_password === '') {
    errors.push('You Password is a required field');
    fields['adminPassword'] = true;
  }

  if (data.password === '') {
    errors.push('Password is a required field');
    fields['password'] = true;
  }

  if (data.confirmPassword === '') {
    errors.push('Confirm Password is a required field');
    fields['confirmPassword'] = true;
  }

  if (data.confirmPassword !== data.password) {
    errors.push('Password and Confirm Password do not match');
    fields['password'] = true;
    fields['confirmPassword'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const locationAddEdit = (data) => {
  var errors = [];
  var fields = {};

  if (data.name === '') {
    errors.push('Location Name is a required field');
    fields['name'] = true;
  }

  if (data.street_address === '') {
    errors.push('Street Address is a required field');
    fields['street_address'] = true;
  }

  if (data.city === '') {
    errors.push('City is a required field');
    fields['city'] = true;
  }

  if (data.state === '') {
    errors.push('State is a required field');
    fields['state'] = true;
  }

  if (data.zipcode === '') {
    errors.push('Zipcode is a required field');
    fields['zipcode'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const practiceProfileEdit = (data) => {
  var errors = [];
  var fields = {};

  if (data.name === '') {
    errors.push('Practice Name is a required field');
    fields['name'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const createPractice = (data) => {
  var errors = [];
  var fields = {};

  const practice_info      = data.practice_info;
  const practice_location  = data.practice_location;

  if (practice_info.name === '') {
    errors.push('Organization Name is a required field');
    fields['practiceName'] = true;
  }

  if (practice_location.name === '') {
    errors.push('Practice Location Name is a required field');
    fields['practiceLocationName'] = true;
  }

  if (practice_location.street_address === '') {
    errors.push('Practice Street Address is a required field');
    fields['practiceStreetAddress'] = true;
  }

  if (practice_location.city === '') {
    errors.push('City is a required field');
    fields['practiceCity'] = true;
  }

  if (practice_location.state === '') {
    errors.push('State is a required field');
    fields['practiceState'] = true;
  }

  if (practice_location.zipcode === '') {
    errors.push('Zipcode is a required field');
    fields['practiceZip'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const userProfileEdit = (data) => {
  var errors = [];
  var fields = {};

  if (data.first_name === '') {
    errors.push('First Name is a required field');
    fields['first_name'] = true;
  }

  if (data.last_name === '') {
    errors.push('Last Name is a required field');
    fields['last_name'] = true;
  }

  if (data.email === '') {
    errors.push('Email is a required field');
    fields['email'] = true;
  }

  if (data.email && data.confirm_email && data.email !== data.confirm_email) {
    errors.push('Email and Confirm Email do not match');
    fields['email'] = true;
    fields['confirm_email'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const validateSignIn = (data) => {
  var errors = [];
  var fields = {};

  if (data.email === '') {
    errors.push('Email is a required field');
    fields['email'] = true;
  }

  if (data.password === '') {
    errors.push('Password is a required field');
    fields['password'] = true;
  }

  var isValid = errors.length === 0 ? true : false;

  return { valid: isValid, errors: errors, fields: fields };
}

const validateSignUp = (data) => {
    var errors = [];
    var fields = {};

    if (data.first_name === '') {
      errors.push('First Name is a required field');
      fields['firstName'] = true;
    }

    if (data.last_name === '') {
      errors.push('Last Name is a required field');
      fields['lastName'] = true;
    }

    if (data.email === '') {
      errors.push('Email is a required field');
      fields['email'] = true;
    }

    if (data.email !== '' && data.confirmEmail !== data.email) {
      errors.push('Email and Confirm Email do not match');
      fields['email'] = true;
      fields['confirmEmail'] = true;
    }

    if (!data.phone_number || data.phone_number === '') {
      errors.push('Cell Phone # is a required field');
      fields['phone_number'] = true;
    }

    var isValid = errors.length === 0 ? true : false;

    return { valid: isValid, errors: errors, fields: fields };
}

const validatePasswordText = (text) => {

   const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
   const lowerCase = "abcdefghijklmnopqrstuvwxyz";
   const numbers = "0123456789";
   const specialChars = "@$!%*?"

   var invalidPasswordMessage = '';
   var validationObject = {
     usedUpperCase: false,
     usedLowerCase: false,
     usedNumber: false,
     usedSpecialCharacter: false,
     usedEightCharacters: false,
     messageText: '',
   }

   if (text.length >= 8) {
     validationObject.usedEightCharacters = true;
   }

   for (var i = 0; i < text.length; i++){
     var char = text.charAt(i);
     validationObject.usedUpperCase = validationObject.usedUpperCase || upperCase.includes(char);
     validationObject.usedLowerCase = validationObject.usedLowerCase  || lowerCase.includes(char);
     validationObject.usedNumber = validationObject.usedNumber  || numbers.includes(char);
     validationObject.usedSpecialCharacter = validationObject.usedSpecialCharacter || specialChars.includes(char);
   }

   if (validationObject.usedUpperCase && validationObject.usedLowerCase && validationObject.usedNumber && validationObject.usedSpecialCharacter) {
     return false;
   } else {
     return true;
   }
 }

 const validatePassword = (password, confirm) => {
   let invalid = {
     password_invalid: false,
     confirm_password_invalid: false,
     strength_error: false,
     message: '',
   }

   if (password === '') {
     invalid.password_invalid = true;
     invalid.message = 'Password is Empty';
     return invalid;
   }

   if (confirm === '') {
     invalid.confirm_password_invalid = true;
     invalid.message = 'Confirm Password is Empty';
     return invalid;
   }

   if (password !== '' && confirm !== password) {
     invalid.confirm_password_invalid = true;
     invalid.message = 'Password & Confirm Password do not match';
     return invalid;
   }

   if (validatePasswordText(password)) {
     invalid.password_invalid = true;
     invalid.strength_error = true;
     invalid.message = 'Password does not meet strength requirements';
     return invalid;
   }

   return invalid;
 }

export default {
  validate,
  validatePassword,
}
